import { render, staticRenderFns } from "./memberServiceRelated.vue?vue&type=template&id=555bbb5e&scoped=true&"
import script from "./memberServiceRelated.vue?vue&type=script&lang=js&"
export * from "./memberServiceRelated.vue?vue&type=script&lang=js&"
import style0 from "./memberServiceRelated.vue?vue&type=style&index=0&id=555bbb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555bbb5e",
  null
  
)

export default component.exports